export default __webpack_public_path__ + "static/media/History.d88b8cab.svg";